<template>
  <el-row>
    <el-col :span="24">
      <div
        class="leftnav"
        :style="{'height':ileftHeight +'px'}"
      >
        <ul>
          <li
            v-for="(item,index) in deps"
            :key="index"
            :class="current == item.id?'dd-this':''"
            @click="changedep(item);"
          ><span>{{item.text}}</span><i></i></li>
        </ul>
      </div>
      <div
        class="main"
        :style="{'height':ibHeight +'px'}"
      >
        <el-row class="mainbox">
          <component v-bind:is="current"></component>

        </el-row>
      </div>
    </el-col>

  </el-row>
</template>

<script>
export default {
  components: {
    depsys: () => import("./sysset/depsys"),
    rolesys: () => import("./sysset/rolesys"),
    userset: () => import("./sysset/userset"),
    marchinesys: () => import("./sysset/machinesys"),
    sysset:() =>import("./sysset/sysset") 
  },
  data() {
    return {
      current: "userset",
      deps: [
        {
          text: "用户管理",
          id: "userset"
        },
        {
          text: "角色管理",
          id: "rolesys"
        },
        // {
        //   text: "隧道管理",
        //   id: "depsys"
        // }
        // {
        //   text: "全局设置",
        //   id: "sysset"
        // }  
      ]
    };
  },
  computed: {
    ibHeight() {
      return window.innerHeight - 96;
    },
     ileftHeight(){
       
      return window.innerHeight - 126;
    },
        
  },
  created() {},
  methods: {
    changedep(opt) {
      if (this.current != opt.id) {
        this.current = opt.id;
      }
    }
  }
};
</script>

<style scoped>
</style>